// extracted by mini-css-extract-plugin
export var about = "index-module--about--+HHBc";
export var brands = "index-module--brands--jwQlc";
export var merchandising = "index-module--merchandising--H8a2R";
export var separator = "index-module--separator--rhlIq";
export var socials = "index-module--socials--HTAHN";
export var story = "index-module--story--tq1Vq";
export var video = "index-module--video--Acdy9";